import brandMark from '../public/brand/local-hoops-mark.jpg'

export const BRAND_MARK_SRC = brandMark
